import { MessageInfo } from "../../../types/info";
import { ResultByTargetAction } from "../../../types/actions";
import { GetResultByTargetResponse } from "../../../../../server/types/request/report/result-by-target";

export type State = {
	loading: boolean;
	info: MessageInfo;
} & GetResultByTargetResponse;

export const initState: State = {
	data: undefined,
	job: undefined,
	loading: true,
	info: {
		isSuccess: true,
		message: "",
	},
};

export const reducer = (state: State, action: ResultByTargetAction): State => {
	switch (action.type) {
		case "loadData":
			return {
				...state,
				loading: false,
				...action.payload,
			};
		case "changeMessageInfo":
			return {
				...state,
				loading: false,
				info: action.payload,
			};
		case "changeLoading":
			return { ...state, loading: action.payload };
		default:
			return state;
	}
};
